import { useNavigate, useParams } from "react-router-dom";
import ModalPageHeader from "../../../global-layout/modal-page-header";
import OpenPdfModalForm from "../open-pdf-modal-form";

function OpenPdfModal({setIsPdfModalOpen, handleRefresh, processUpdated, siteConfigDetails, pdfOptions, isPdfLoading, setPdfLoading  }: any) {
  const navigate = useNavigate();

  return (
    <div className="w-full h-full">
      <div className="w-full h-full flex flex-col">
        <ModalPageHeader
          title={"PDF Download"}
          handleClose={() => setIsPdfModalOpen(false)}
        />
        <div className="w-full h-full flex-auto">
          <div className="w-full h-full px-[4.7rem] pt-[3.7rem]">
            <OpenPdfModalForm handleRefresh={handleRefresh} setIsPdfModalOpen={setIsPdfModalOpen} processUpdated={processUpdated} siteConfigDetails={siteConfigDetails} pdfOptions={pdfOptions} isPdfLoading={isPdfLoading} setPdfLoading={setPdfLoading} />
          </div>
        </div>
      </div>
    </div>
  );
}
export default OpenPdfModal;
